// Single source of truth for brand values. The MUI theme, the Aurora and the
// /brand page all read from here so the guidelines can never drift from the app.

export const colors = {
  orange: '#E65A2F',
  campari: '#D4432A',
  vermouth: '#8B1D1D',
  peel: '#FFF4EC',
  ink: '#1E1411',
  ice: '#FFFFFF',
};

export const palette = [
  { name: 'Groni Orange', token: 'orange', hex: colors.orange, role: 'Primary. Logo, buttons, highlights.', onColor: colors.ice },
  { name: 'Campari', token: 'campari', hex: colors.campari, role: 'Pressed states, gradients, emphasis.', onColor: colors.ice },
  { name: 'Vermouth', token: 'vermouth', hex: colors.vermouth, role: 'Depth. Aurora shadows, dark surfaces.', onColor: colors.peel },
  { name: 'Peel', token: 'peel', hex: colors.peel, role: 'Warm background and soft fills.', onColor: colors.ink },
  { name: 'Ink', token: 'ink', hex: colors.ink, role: 'Body text and dark mode surfaces.', onColor: colors.peel },
  { name: 'Ice', token: 'ice', hex: colors.ice, role: 'Cards and reversed logo.', onColor: colors.ink },
];

export const auroraStops = [colors.vermouth, colors.orange, colors.campari];

export const fonts = {
  body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
};

export const radii = { sm: 10, md: 16, lg: 24, pill: 999 };

// Motion tokens. Durations in seconds (framer-motion) with ms equivalents for CSS.
export const motion = {
  duration: { fast: 0.15, base: 0.25, slow: 0.4, pour: 1.2 },
  ease: {
    standard: [0.2, 0, 0, 1],
    enter: [0, 0, 0.2, 1],
    exit: [0.4, 0, 1, 1],
  },
  spring: {
    snappy: { type: 'spring', stiffness: 500, damping: 30 },
    bouncy: { type: 'spring', stiffness: 380, damping: 14 },
    gentle: { type: 'spring', bounce: 0.2, duration: 0.6 },
  },
};

export const cssEase = (curve) => `cubic-bezier(${curve.join(', ')})`;
